export default __webpack_public_path__ + "assets/TilePlaceholder.a76780.png";